export default 
[
  {
    id: 0,
    nome: 'Valor bruto'
  },
  {
    id: 1,
    nome: 'Valor líquido'
  }
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-pagamento.js